import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import LoaderGif from '@components/common/LoaderGif/LoaderGif';

import useTranslation from '@hooks/useTranslation';

import type { ILocationAsset } from '../../model/locationAsset';
import { selectSensorSearch } from '../../store/useSensorStore';
import EmptyFilterBlock from '../EmptyFilterBlock/EmptyFilterBlock';
import SensorsEquipmentItem from '../SensorsEquipmentItem/SensorsEquipmentItem';
import SensorsLocationsSkeleton from './SensorsLocationsSkeleton';
import style from './style.module.scss';

interface IProps {
  locationsAssetsList?: Array<ILocationAsset>;
  isFetching?: boolean;
}

const SensorsLocations: React.FC<IProps> = ({ locationsAssetsList, isFetching }) => {
  const { t } = useTranslation();

  const searchValue = selectSensorSearch();

  if (isFetching) {
    return <SensorsLocationsSkeleton />;
  }

  if (locationsAssetsList && !locationsAssetsList?.length) {
    return (
      <div className={style.emptyBlockWrapper}>
        <EmptyFilterBlock
          mainText={t('No data available at the moment')}
          extraText={t('Try adjusting your filters or add new entries to see data here')}
        />
      </div>
    );
  }

  return (
    <div className={style.locationsBlock}>
      {locationsAssetsList?.map((location) => (
        <div key={uuidv4()} className={style.locationItem}>
          <div className={style.locationName}>{searchValue ? location.pathName : location.name}</div>
          <div className={style.sensorsBlock}>
            {location.equipments?.map((item) => <SensorsEquipmentItem key={uuidv4()} equipment={item} />)}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SensorsLocations;
